import { enqueueSnackbar, DownloadFile } from 'actions';
import {
	boaImportRequest, boaImportSuccess, boaImportFailure,
	boaGetLastUpdateRequest, boaGetLastUpdateSuccess, boaGetLastUpdateFailure,
	boaGenerateRequest, boaGenerateSuccess, boaGenerateFailure,
	helixGetStatusRequest, helixGetStatusSuccess, helixGetStatusFailure,
	helixFetchRequest, helixFetchSuccess, helixFetchFailure,
	helixExportRequest, helixExportSuccess, helixExportFailure,
	helixGetQueueRequest, helixGetQueueSuccess, helixGetQueueFailure,
} from './backOnAirActions';
import {
	BackOnAirImportFileRequest,
	BackOnAirGetLastUpdateRequest,
	BackOnAirGenerateResultRequest,
	HelixGetStatusRequest,
	HelixFetchDataRequest,
	HelixExportResultRequest,
	HelixGetQueueRequest,
} from '../requests/backOnAirRequests';

// ─── BACK ON AIR ──────────────────────────────────────────────────────────────

export const boaGetLastUpdate = () => async (dispatch) => {
	dispatch(boaGetLastUpdateRequest());
	await BackOnAirGetLastUpdateRequest().then((response) => {
		const raw = response.data?.backOnAirLastUpdate ?? response.data?.BackOnAirLastUpdate ?? response.data;
		dispatch(boaGetLastUpdateSuccess({
			user:      raw?.insertUser ?? raw?.InsertUser ?? null,
			timestamp: raw?.insertDate ?? raw?.InsertDate ?? null,
		}));
	}).catch((error) => {
		dispatch(boaGetLastUpdateFailure(error?.message));
	});
};

export const boaImportFile = (userId, file) => async (dispatch) => {
	dispatch(boaImportRequest());
	await BackOnAirImportFileRequest(userId, file).then((response) => {
		dispatch(boaImportSuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'File imported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(boaImportFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const boaGenerateResult = (userId) => async (dispatch) => {
	dispatch(boaGenerateRequest());
	await BackOnAirGenerateResultRequest(userId).then((response) => {
		dispatch(boaGenerateSuccess(response.data));
		dispatch(DownloadFile(response.data));
		dispatch(enqueueSnackbar({ message: 'Results generated successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(boaGenerateFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

// ─── HELIX ────────────────────────────────────────────────────────────────────

export const helixGetStatus = () => async (dispatch) => {
	dispatch(helixGetStatusRequest());
	try {
		const response = await HelixGetStatusRequest();
		const data = response.data;
		dispatch(helixGetStatusSuccess(data));
		return data;
	} catch (error) {
		dispatch(helixGetStatusFailure(error?.message));
	}
};

export const helixFetchData = (userId) => async (dispatch) => {
	dispatch(helixFetchRequest());
	await HelixFetchDataRequest(userId).then((response) => {
		dispatch(helixFetchSuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'Helix data fetched successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(helixFetchFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const helixExportResult = (userId) => async (dispatch) => {
	dispatch(helixExportRequest());
	await HelixExportResultRequest(userId).then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(helixExportSuccess(response.data));
		dispatch(enqueueSnackbar({ message: 'Helix result exported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(helixExportFailure(error?.message));
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
		}
	});
};

export const helixGetQueue = () => async (dispatch) => {
	dispatch(helixGetQueueRequest());
	await HelixGetQueueRequest().then((response) => {
		dispatch(helixGetQueueSuccess(response.data));
	}).catch((error) => {
		dispatch(helixGetQueueFailure(error?.message));
	});
};